import ManageContract from './ManageContract'
import SelectContract from './SelectContract'

export const getCompanyTabs = (modeProps) => [
  { tabName: 'Généraux', tabIndex: '1' },
  { tabName: 'Contacts', tabIndex: '2' },
  { tabName: 'CGV', tabIndex: '3' },
  { tabName: 'Emails', tabIndex: '4', isDisplay: () => modeProps === 'normal' },
  { tabName: 'Emails template', tabIndex: '5', isDisplay: () => modeProps === 'normal' },
  { tabName: 'Abonnement', tabIndex: '6', isDisplay: () => modeProps === 'normal' }
]

export const getCompanyFields = ({ attach, cachet }) => [
  // --- Tab 1: General ---
  [
    {
      tab: '1',
      name: 'logo',
      label: 'Logo',
      type: 'image',
      file: (data) => data.attachments?.find((a) => a.type === 'logo')
    }
  ],
  [
    {
      tab: '1',
      name: 'file',
      label: 'Logo',
      type: 'file',
      file: attach,
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' },
        {
          rule: 'maxWidthHeiht=1280;720',
          error: 'Résolution du fichier trop élevée, selectionner un fichier avec une résolution max 1280x720'
        }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'cachet',
      label: 'Cachet',
      type: 'image',
      file: (data) => data.attachments?.find((a) => a.type === 'cachet')
    }
  ],
  [
    {
      tab: '1',
      name: 'fileCachet',
      label: 'Cachet',
      type: 'file',
      file: cachet,
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' },
        {
          rule: 'maxWidthHeiht=1280;720',
          error: 'Résolution du fichier trop élevée, selectionner un fichier avec une résolution max 1280x720'
        }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'name',
      label: 'Nom',
      type: 'text',
      sizeDivided: 2,
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Nom obligatoire' },
        { rule: 'maxlen=100', error: 'Nom doit contenir moins de 100 caractères' },
        { rule: 'minlen=3', error: 'Nom doit contenir au moins 3 caractères' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'siret',
      label: 'SIRET',
      type: 'text',
      sizeDivided: 2,
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'SIRET obligatoire' },
        { rule: 'number', error: 'SIRET doit contenir uniquement des chiffres' },
        { rule: 'len=14', error: 'SIRET doit contenir 14 caractères' }
      ]
    }
  ],
  [
    {
      tab: '1',
      name: 'siren',
      label: 'SIREN',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'SIREN obligatoire' },
        { rule: 'number', error: 'SIREN doit contenir uniquement des chiffres' },
        { rule: 'len=9', error: 'SIREN doit contenir 9 caractères' }
      ]
    },
    {
      tab: '1',
      name: 'ape',
      label: 'Code APE',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Code APE obligatoire' },
        { rule: 'len=5', error: 'Code APE doit contenir 5 caractères' }
      ]
    }
  ],
  [
    { tab: '1', name: 'is_acre', label: 'ACRE', type: 'checkbox' },
    {
      tab: '1',
      name: 'acre_end',
      label: 'Date fin ACRE',
      type: 'date',
      isDisplay: (data) => data.is_acre,
      required: true,
      validation: [{ rule: 'req', error: 'Date fin ACRE obligatoire' }]
    }
  ],

  // --- Tab 2: Contacts ---
  [
    {
      tab: '2',
      name: 'phone',
      label: 'Téléphone',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Téléphone obligatoire' },
        { rule: 'len=10', error: 'Téléphone doit contenir 10 caractères' },
        { rule: 'number', error: 'Téléphone doit contenir uniquement des chiffres' }
      ]
    },
    {
      tab: '2',
      name: 'email',
      label: 'Email',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Email obligatoire' },
        { rule: 'email', error: 'Format Email' }
      ]
    }
  ],
  [
    {
      tab: '2',
      name: 'website',
      label: 'Site internet',
      type: 'text',
      sizeDivided: 2,
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Site internet obligatoire' }]
    }
  ],
  [{ tab: '2', name: 'label_siege', label: 'Siège', type: 'label' }],
  [
    {
      tab: '2',
      name: 'address1',
      label: 'Adresse',
      type: 'text',
      sizeDivided: 2,
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Adresse obligatoire' }]
    }
  ],
  [
    {
      tab: '2',
      name: 'address2',
      label: "Complément d'adresse",
      type: 'text',
      sizeDivided: 2,
      required: false,
      fullWidth: true
    }
  ],
  [
    {
      tab: '2',
      name: 'zip',
      label: 'Code postal',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Code postal obligatoire' }]
    },
    {
      tab: '2',
      name: 'city',
      label: 'Ville',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Ville obligatoire' }]
    }
  ],
  [{ tab: '2', name: 'label_siege', label: 'Bureau', type: 'label' }],
  [{ tab: '2', name: 'is_siege', label: 'Adresse bureau différente', type: 'checkbox' }],
  [
    {
      tab: '2',
      name: 'office_address1',
      label: 'Adresse',
      type: 'text',
      sizeDivided: 2,
      required: true,
      fullWidth: true,
      isDisplay: (data) => data.is_siege,
      validation: [{ rule: 'req', error: 'Adresse obligatoire' }]
    }
  ],
  [
    {
      tab: '2',
      name: 'office_address2',
      label: "Complément d'adresse",
      type: 'text',
      sizeDivided: 2,
      required: false,
      fullWidth: true,
      isDisplay: (data) => data.is_siege
    }
  ],
  [
    {
      tab: '2',
      name: 'office_zip',
      label: 'Code Postal',
      type: 'text',
      required: true,
      fullWidth: true,
      isDisplay: (data) => data.is_siege,
      validation: [{ rule: 'req', error: 'Code Postal obligatoire' }]
    },
    {
      tab: '2',
      name: 'office_city',
      label: 'Ville',
      type: 'text',
      required: true,
      fullWidth: true,
      isDisplay: (data) => data.is_siege,
      validation: [{ rule: 'req', error: 'Ville obligatoire' }]
    }
  ],

  // --- Tab 3: CGV ---
  [{ tab: '3', name: 'label_cgv_pro', label: 'CGV Pro', type: 'label' }],
  [{ tab: '3', name: 'cgv_pro', type: 'joditEditor', fullWidth: true }],
  [{ tab: '3', name: 'label_cgv_particulier', label: 'CGV Particulier', type: 'label' }],
  [{ tab: '3', name: 'cgv_particulier', type: 'joditEditor', fullWidth: true }],

  // --- Tab 4: Emails ---
  [
    {
      tab: '4',
      name: 'img_header',
      label: 'Image Header',
      type: 'image',
      file: (data) => data.img_header
    }
  ],
  [
    {
      tab: '4',
      name: 'img_header',
      label: 'Image Header',
      type: 'file',
      required: false,
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' }
      ]
    }
  ],
  [
    {
      tab: '4',
      name: 'img_body',
      label: 'Image Body',
      type: 'image',
      file: (data) => data.img_body
    }
  ],
  [
    {
      tab: '4',
      name: 'img_body',
      label: 'Image Body',
      type: 'file',
      required: false,
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' }
      ]
    }
  ],
  [
    { tab: '4', name: 'header_color', label: 'Couleur en-tête', type: 'color' },
    { tab: '4', name: 'footer_color', label: 'Couleur pied de page', type: 'color' },
    { tab: '4', name: 'footerFont_color', label: 'Couleur police pied de page', type: 'color' }
  ],

  // --- Tab 5: Email Templates ---
  [{ tab: '5', name: 'label_intervention_template', label: 'Email Intervention Template', type: 'label' }],
  [
    {
      tab: '5',
      name: 'intervention_email_template',
      type: 'joditEditor',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Intervention Template obligatoire' }]
    }
  ],
  [{ tab: '5', name: 'label_attestation_template', label: 'Email Attestation matériel Template', type: 'label' }],
  [
    {
      tab: '5',
      name: 'attestation_email_template',
      type: 'joditEditor',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Attestation Matériel Template obligatoire' }]
    }
  ],
  [{ tab: '5', name: 'label_facture_template', label: 'Email Facture Template', type: 'label' }],
  [
    {
      tab: '5',
      name: 'invoice_email_template',
      type: 'joditEditor',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Facture Template obligatoire' }]
    }
  ],
  [{ tab: '5', name: 'label_devis_template', label: 'Email Devis Template', type: 'label' }],
  [
    {
      tab: '5',
      name: 'quote_email_template',
      type: 'joditEditor',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Devis Template obligatoire' }]
    }
  ],
  [{ tab: '5', name: 'label_avoir_template', label: 'Email Avoir Template', type: 'label' }],
  [
    {
      tab: '5',
      name: 'credit_email_template',
      type: 'joditEditor',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Avoir Template obligatoire' }]
    }
  ],

  // --- Tab 6: Contract ---
  [
    {
      tab: '6',
      name: 'contract',
      type: 'component',
      component: (company) =>
        company.is_free_account ? (
          <SelectContract company={company.id} contact={company.email} />
        ) : (
          <ManageContract company={company.id} />
        )
    }
  ]
]
